export default __webpack_public_path__ + "formulario2.jpg";